import { Button, Card } from "@aqar-app/aqar-design-system";
import { Icon } from "@/components/icon";
import styles from "./.module.scss";

function DeveloperCard({ plan }) {
  const { note, description } = plan || {};
  const { features, title } = JSON.parse(description)?.ar || { ar: {} };
  return (
    <Card className={`${styles.card} ${styles.developer}`} key={title}>
      <div className={`${styles.cardHeader} ${styles.developer}`}>
        <Icon name="REPackage-colored" alt="red" width={30} height={30} />
        <h3 className={styles.title}>{title}</h3>
      </div>
      <hr />
      <div className={styles.cardContent}>
        <ul className={`${styles.features} ${styles.developer}`}>
          {features?.map((feature) => {
            return (
              <li
                key={feature}
                className={`${styles.featureLine} ${styles.developer}`}
              >
                <Icon
                  name="check-blue"
                  className={styles.featureCheck}
                  width={20}
                  height={20}
                />
                {feature}
              </li>
            );
          })}
        </ul>
        <div className={styles.cardFooter}>
          <Button
            priority="primary"
            className={styles.actionButton}
            onClick={() => {
              window.location.href = "mailto:sales@aqar.fm";
            }}
          >
            التواصل معنا
          </Button>
          <Button
            size="x-small"
            className={styles.developerFile}
            prefixIcon="Agreement-Pdf"
            label="استعراض ملف المميزات و الخدمات"
            onClick={() =>
              window.open(
                "https://assets.aqar.fm/files/RD-Services.pdf",
                "_blank",
              )
            }
          />
          {note?.split("\n")?.length > 0 && (
            <div className={styles.notesContainer}>
              <div className={styles.notesHeader}>
                <Icon
                  name="ListingTerms-note"
                  alt="notes"
                  width={20}
                  height={20}
                  className={styles.noteIcon}
                />
                <p className={styles.noteTitle}>توضيحات</p>
              </div>
              <ul className={styles.notesList}>
                {note?.split("\n").map(
                  (currentNote) =>
                    currentNote && (
                      <li key={currentNote}>
                        <span className={styles.note}>* {currentNote}</span>
                      </li>
                    ),
                )}
              </ul>
            </div>
          )}
        </div>
      </div>
    </Card>
  );
}

export default DeveloperCard;
